import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import CancellationPolicy from "./components/CancellationPolicy";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import AdminDashboard from "./components/AdminDashboard";
import AdminLogin from "./components/AdminLogin";
import SubscriberDashboard from "./components/SubscriberDashboard";
import LoginPage from "./components/LoginPage";
import ThankYouPage from "./components/ThankYouPage";
import CoursesPage from "./components/CoursesPage";
import CourseDetailPage from "./components/CourseDetailPage";
import CoursePlayerPage from "./components/CoursePlayerPage";
import LessonSharePage from "./components/LessonSharePage";
import FreeLearningPage from "./components/FreeLearningPage";
import MarketOutlookDashboard from "./pages/MarketOutlookDashboard";
import MarketSnapshotPage from "./pages/MarketSnapshotPage";
import MasterclassPage from "./pages/MasterclassPage";
import WorkshopPage from "./pages/WorkshopPage";
import InstallPwaPrompt from "./components/InstallPwaPrompt";
import SiteHeader from "./components/SiteHeader";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import TelegramFloatingButton from "./components/TelegramFloatingButton";
import TelegramNudge from "./components/TelegramNudge";
import MetaPixelTracker from "./components/MetaPixelTracker";
import { Toaster } from "./components/Toaster";

// Routes that already contain their own header (avoid double-nav)
const OWN_HEADER_ROUTES = ["/", "/home", "/welcome", "/market-intelligence", "/thank-you"];
// Prefix-matched routes that ship their own header (course pages)
const OWN_HEADER_PREFIXES = ["/courses"];
// Routes where site chrome should be hidden entirely (app-shell UI)
const HIDE_CHROME_PREFIXES = ["/admin", "/dashboard"];

const SiteChrome = () => {
  const { pathname } = useLocation();
  if (HIDE_CHROME_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  const hideHeader =
    OWN_HEADER_ROUTES.includes(pathname) ||
    OWN_HEADER_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

  return (
    <>
      {!hideHeader && (
        <>
          <SiteHeader />
          {/* Spacer so page content isn't hidden under the fixed header */}
          <div className="h-16 md:h-[72px]" aria-hidden="true" />
        </>
      )}
      <WhatsAppFloatingButton />
      <TelegramFloatingButton />
      <TelegramNudge />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <InstallPwaPrompt />
      <Toaster />
      <BrowserRouter>
        <MetaPixelTracker />
        <SiteChrome />
        <Routes>
          <Route path="/" element={<MarketOutlookDashboard />} />
          <Route path="/market-snapshot" element={<MarketSnapshotPage />} />
          <Route path="/market-snapshot/:date" element={<MarketSnapshotPage />} />
          <Route path="/home" element={<LandingPage />} />
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/dashboard" element={<SubscriberDashboard />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:courseId" element={<CourseDetailPage />} />
          <Route path="/courses/:courseId/learn" element={<CoursePlayerPage />} />
          <Route path="/courses/:courseId/lesson/:lessonId" element={<LessonSharePage />} />
          <Route path="/free-learning" element={<FreeLearningPage />} />
          <Route path="/free-learning/:videoId" element={<FreeLearningPage />} />
          <Route path="/market-intelligence" element={<MarketOutlookDashboard />} />
          <Route path="/masterclass" element={<MasterclassPage />} />
          <Route path="/workshop" element={<WorkshopPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
